import { ViewCell } from '@theme/components/grid/ng2-smart-table/components/cell/cell-view-mode/view-cell';
import { OnInit, Input, Component, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'reorder-cell',
    template: `
    <div (click)="up()" class="btn-reorder" [ngClass]="{'disableDiv': value.disabled}"><i class="fas fa-angle-up"></i></div>
    <div (click)="down()" class="btn-reorder" [ngClass]="{'disableDiv': value.disabled}"><i class="fas fa-angle-down"></i></div>
  `,
    styleUrls: ['./reorder-cell.component.scss'],
    standalone: false
})
export class ReorderCellComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: any;
  @Input() rowData: any;
  @Input() settings: any;
  @Output() onReorder: EventEmitter<any> = new EventEmitter();


  ngOnInit() {
  }

  up() {
    if (this.value.disabled) return;
    this.onReorder.emit({ data: this.rowData, index: this.value.index, action: 'up' });
  }
  down() {
    if (this.value.disabled) return;
    this.onReorder.emit({ data: this.rowData, index: this.value.index, action: 'down' });
  }
}
